/* eslint-disable import/prefer-default-export */
import { usePage } from '@inertiajs/inertia-vue3';
import { onMounted } from 'vue';
import useSessionStore from '@/Stores/useSessionStore';
import { USER_ROLE } from '@/Utils/vice-constants';

export function useSetupSessionData() {
  const pageProps = usePage().props.value;
  const { session, user: authUser } = pageProps;
  const sessionStore = useSessionStore();

  const userIsObserver = () => {
    if (sessionStore.isClinician) return false;
    const thisUser = session.invites.find((singleUser) => singleUser.user_id === authUser.id);
    return thisUser?.user_role === USER_ROLE.OBSERVER;
  };

  onMounted(() => {
    sessionStore.isClinician = pageProps.isClinician;
    sessionStore.sessionDetails = session;
    sessionStore.userIsObserver = userIsObserver();
    sessionStore.authUser = authUser;
  });

  return { sessionStore, pageProps, session, authUser };
}
